module.exports = __webpack_public_path__ + "static/web-09f2b24e110836b7b45c0210de2df6e9.png";